import { render, staticRenderFns } from "./menu-two-option-large.vue?vue&type=template&id=461ec4d9&scoped=true&"
import script from "./menu-two-option-large.vue?vue&type=script&lang=js&"
export * from "./menu-two-option-large.vue?vue&type=script&lang=js&"
import style0 from "./menu-two-option-large.vue?vue&type=style&index=0&id=461ec4d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../WebVR/webvr-infest/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ec4d9",
  null
  
)

export default component.exports